<template>
  <div>
    <van-sticky>
      <van-search v-model="paramsForm.agentName" show-action placeholder="请输入要查询的姓名" @search="onSearch" @cancel="onCancel" />
    </van-sticky>
    <van-pull-refresh v-show="!loadingShow" :disabled="refreshingFlag" v-model="refreshing" @refresh="onRefreshs" success-text="刷新成功">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad"
      >
        <vanCollapseContent class="pag" :list="list"></vanCollapseContent>
      </van-list>
    </van-pull-refresh>
    <div v-show="loadingShow" class="loading">
      <van-loading type="spinner" vertical>加载中...</van-loading>
    </div>
    <div class="footer">
      <p class="footerTitle"></p>
    </div>
  </div>
</template>

<script>
import { agent } from '@/api/user.js'
import vanCollapseContent from '@/components/AgentMgVanCollapseContenty'
export default {
  components: { vanCollapseContent },
  props: {},
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      loadingShow: false,
      searchValue: '',
      paramsForm: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        agentName: ''
      },
      // 刷新节流阀
      refreshingFlag: false,
      // list是否有数
      closeFlag: false,
      finishedText: '到底了'
    }
  },
  watch: {},
  computed: {},
  methods: {
    async onSearch () {
      if (this.paramsForm.agentName) {
        this.closeFlag = true
      } else {
        this.closeFlag = false
      }
      this.loadingShow = true
      const { data: res } = await agent(this.paramsForm)
      this.list = res.extend.rows
      if (this.list.length === 0) {
        this.finishedText = '未查询到该代理商'
      }
      this.$nextTick(_ => {
        this.loadingShow = false
      })
    },
    async onCancel () {
      if (!this.closeFlag) return
      this.closeFlag = false
      this.finishedText = '没有更多代理商了'
      this.loadingShow = true
      this.paramsForm.agentName = ''
      const { data: res } = await agent(this.paramsForm)
      this.list = res.extend.rows
      this.$nextTick(_ => {
        this.loadingShow = false
      })
    },
    async onLoad () {
      this.finishedText = '没有更多代理商了'
      const { data: res } = await agent(this.paramsForm)
      const { rows } = res.extend
      this.list.push(...rows)
      this.loading = false
      if (rows.length >= this.paramsForm.limit) {
        this.paramsForm.page++
      } else {
        this.finished = true
      }
      this.refreshing = false
      this.$nextTick(_ => {
        this.refreshingFlag = false
      })
    },
    onRefreshs () {
      this.refreshingFlag = true
      // 清空列表数据
      this.finished = false
      this.list = []
      this.paramsForm.page = 1
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    }
  },
  beforeCreate () {},
  created () {
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .van-search {
    background-color: #eee;
  }
  .pag {
    margin-top: 20px;
  }
  .footer {
    height: 10px;
    .footerTitle {
      font-size: 15px;
      text-align: center;
      color: rgb(182, 182, 182);
      line-height: 10px;
    }
  }
  .loading {
    margin: 30px 0;
  }
</style>
